import React, { FC } from 'react';
import { EPurchaseOrderStatus } from 'entities/PurchaseOrder/PurchaseOrder.models';

interface IComponentProps {
  status: string;
}

export const PurchaseOrderStatusDot: FC<IComponentProps> = ({ status }) => {
  const color = () => {
    switch (status) {
      case EPurchaseOrderStatus.ForApproval: {
        return 'yellow';
      }
      case EPurchaseOrderStatus.Preparing: {
        return 'blue';
      }
      case EPurchaseOrderStatus.InTransit: {
        return 'purple';
      }
      case EPurchaseOrderStatus.Delivered: {
        return 'green';
      }
      case EPurchaseOrderStatus.Canceled: {
        return 'red';
      }
      default: {
        return 'gray';
      }
    }
  };

  return <div className={`purchase-order-status-dot ${color()}`} />;
};
